/**
 * usePermissionPersistence Hook
 * Tracks user permission history in localStorage
 */

import { useState, useCallback, useEffect } from 'react'
import {
  getPermissionHistory,
  addPermissionHistoryEntry,
  hasSeenEducation,
  markEducationShown,
  getLastPermissionCheck,
  updateLastPermissionCheck,
  hasPersistentPermissionIssues,
  getPersonalizedMessage,
} from 'src/services/mediaPermissions'

export const usePermissionPersistence = (sessionType = 'general') => {
  const [history, setHistory] = useState([])
  const [educationShown, setEducationShown] = useState(false)
  const [lastCheck, setLastCheck] = useState(null)
  const [persistentIssues, setPersistentIssues] = useState(false)

  // Load initial data
  useEffect(() => {
    const loadData = () => {
      try {
        setHistory(getPermissionHistory())
        setEducationShown(hasSeenEducation(sessionType))
        setLastCheck(getLastPermissionCheck())
        setPersistentIssues(hasPersistentPermissionIssues())
      } catch (error) {
        console.error('Error loading permission persistence data:', error)
      }
    }

    loadData()
  }, [sessionType])

  // Add a new history entry
  const addEntry = useCallback(
    (entry) => {
      try {
        addPermissionHistoryEntry(entry)
        setHistory(getPermissionHistory())
        setPersistentIssues(hasPersistentPermissionIssues())
      } catch (error) {
        console.error('Error adding permission history entry:', error)
      }
    },
    [],
  )

  // Mark education as shown
  const markEducationComplete = useCallback(() => {
    try {
      markEducationShown(sessionType)
      setEducationShown(true)
    } catch (error) {
      console.error('Error marking education as shown:', error)
    }
  }, [sessionType])

  // Update last check time
  const updateCheckTime = useCallback(() => {
    try {
      updateLastPermissionCheck()
      setLastCheck(new Date())
    } catch (error) {
      console.error('Error updating last check time:', error)
    }
  }, [])

  // Get personalized message
  const personalizedMessage = useCallback(() => {
    return getPersonalizedMessage()
  }, [])

  return {
    history,
    educationShown,
    lastCheck,
    persistentIssues,
    addEntry,
    markEducationComplete,
    updateCheckTime,
    personalizedMessage,
  }
}

export default usePermissionPersistence


















